var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgKitchen = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M29.662 14.785c1.568 0 2.838 1.431 2.838 3.195 0 1.765-1.27 3.195-2.838 3.195"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M29.662 16.458c.746 0 1.352.682 1.352 1.522s-.605 1.522-1.352 1.522M10.338 21.175c-1.567 0-2.838-1.431-2.838-3.195 0-1.765 1.27-3.195 2.838-3.195"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M10.338 19.501c-.746 0-1.351-.682-1.351-1.52 0-.842.604-1.524 1.35-1.524M29.535 14.56v10.19c0 .673-4.197 1.75-9.603 1.75-5.404 0-9.497-1.077-9.497-1.75V14.598M18.16 10.32c0-.497.823-.9 1.84-.9s1.84.403 1.84.9"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M29.737 14.515s-4.806.939-9.803.939-9.7-.94-9.7-.94c0-1.652 4.365-4.194 9.751-4.194s9.752 2.542 9.752 4.195Z"
}))));
export default SvgKitchen;